import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sv-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "sv-page-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "sv-page-header__eyebrow" }, "Visão geral da operação"),
    /*#__PURE__*/_createElementVNode("h1", null, "Dashboard"),
    /*#__PURE__*/_createElementVNode("p", null, "Acompanhe volume, duração, armazenamento e processamento das gravações.")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sv-section-heading" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Gravações de hoje")
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xxl-7 col-xxxl-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-3 col-12 col-sm-6 col-xl-3 col-xxl-4 col-xxxl-3 col-md-6" }
const _hoisted_8 = { class: "col-lg-3 col-12 col-sm-6 col-xl-3 col-xxl-4 col-xxxl-3 col-md-6" }
const _hoisted_9 = { class: "col-lg-3 col-12 col-sm-6 col-xl-3 col-xxl-4 col-xxxl-3 col-md-6" }
const _hoisted_10 = { class: "col-lg-3 col-12 col-sm-6 col-xl-3 col-xxl-4 col-xxxl-3 col-md-6" }
const _hoisted_11 = { class: "col-xxl-12 col-xxxl-12" }
const _hoisted_12 = { class: "col-xxl-12 col-xxxl-12" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sv-section-heading" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Gravações do mês atual")
  ])
], -1)
const _hoisted_14 = { class: "col-xxl-4" }
const _hoisted_15 = { class: "col-xxl-8 col-xxxl-8" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sv-section-heading" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Gravações do ano atual")
  ])
], -1)
const _hoisted_17 = { class: "col-xxl-12 col-xxxl-12" }
const _hoisted_18 = { class: "row col-12 flex-column flex-sm-row area-dashboard-graphic-semester-and-quarters" }
const _hoisted_19 = { class: "d-flex flex-column justify-content-around mb-10 mt-30 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "sv-section-heading" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Semestre atual")
], -1)
const _hoisted_21 = { class: "d-flex flex-column justify-content-around mb-10 mt-30 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "sv-section-heading" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Trimestre atual")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sv-section-heading" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Gravações de todo o período")
  ])
], -1)
const _hoisted_24 = { class: "col-xxl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardDaySuccess = _resolveComponent("DashboardDaySuccess")!
  const _component_DashboardDayError = _resolveComponent("DashboardDayError")!
  const _component_DashboardDayTime = _resolveComponent("DashboardDayTime")!
  const _component_DashboardDaySize = _resolveComponent("DashboardDaySize")!
  const _component_DashboardCardsTodayInformations = _resolveComponent("DashboardCardsTodayInformations")!
  const _component_DashboardUploadTotalsHour = _resolveComponent("DashboardUploadTotalsHour")!
  const _component_MetricDashboardMonthGraphic = _resolveComponent("MetricDashboardMonthGraphic")!
  const _component_CardsDashboardMonth = _resolveComponent("CardsDashboardMonth")!
  const _component_MetricDashboardYearGraphic = _resolveComponent("MetricDashboardYearGraphic")!
  const _component_MetricDashboardSemesterGraphic = _resolveComponent("MetricDashboardSemesterGraphic")!
  const _component_MetricDashboardQuarterGraphic = _resolveComponent("MetricDashboardQuarterGraphic")!
  const _component_MetricDashboardTotals = _resolveComponent("MetricDashboardTotals")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DashboardDaySuccess)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_DashboardDayError)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_DashboardDayTime)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_DashboardDaySize)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_DashboardCardsTodayInformations)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_DashboardUploadTotalsHour)
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_MetricDashboardMonthGraphic)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_CardsDashboardMonth)
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_MetricDashboardYearGraphic)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", null, [
            _createVNode(_component_MetricDashboardSemesterGraphic)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", null, [
            _createVNode(_component_MetricDashboardQuarterGraphic)
          ])
        ])
      ]),
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_MetricDashboardTotals)
      ])
    ])
  ]))
}